interface CollapsePanelTitleProps {
  children: React.ReactNode;
}

export const CollapsePanelTitle: React.FC<CollapsePanelTitleProps> = ({ children }) => {
  return <span className="font-weight-600 font-size-14">{children}</span>;
};
